import { AddNorthlightRenewals } from "./sheet-add";

export function NorthlightRenewals() {
    return (
        <>
        <AddNorthlightRenewals />
        </>
    )
}